// SAT V5 Zone - Main Zone Component
import { DsIcon } from '@ice-web-app/designSystem';
import { loadModuleNamespace } from '@ice-web-app/shared-i18n';
import { useGlobalStore, useSidebarStore } from '@ice-web-app/shared-store';
import { getCurrentEcosystemBasePath } from '@ice-web-app/shared-utils';
import { type FC, useEffect } from 'react';
import { sat5AR, sat5DE, sat5EN } from '../locales';
import { ZoneRoutes } from '../routes/ZoneRoutes';
import { routes } from '../routes/routes';

export const SatV5Zone: FC = () => {
  const { setMenuItems, setShowEntityMenu, setBackPath } = useSidebarStore();
  const { setShowMainSidebar } = useGlobalStore();
  const showMainSidebar = localStorage.getItem('showMainSidebar') === 'true';

  useEffect(() => {
    setShowMainSidebar(showMainSidebar);
  }, [showMainSidebar, setShowMainSidebar]);

  useEffect(() => {
    setShowEntityMenu(false);
  }, [setShowEntityMenu]);

  useEffect(() => {
    setBackPath(getCurrentEcosystemBasePath() || '/');

    setMenuItems([
      // 1. Dashboard
      {
        title: 'Dashboard',
        icon: <DsIcon icon="HOME" />,
        path: routes.dashboard,
      },
      // 2. Upload
      {
        title: 'Upload',
        icon: <DsIcon icon="UPLOAD" />,
        path: routes.upload,
      },
      // 3. Curriculum Planning (with submenu)
      {
        title: 'Curriculum Planning',
        icon: <DsIcon icon="CALENDAR" />,
        path: routes.curriculumPlanning.import,
        submenu: [
          {
            title: 'Curriculum Import',
            path: routes.curriculumPlanning.import,
          },
          {
            title: 'Curriculum Plan',
            path: routes.curriculumPlanning.plan,
          },
        ],
      },
      // 4. School Structure
      {
        title: 'School Structure',
        icon: <DsIcon icon="SCHOOL_STAFF" />,
        path: routes.schoolStructure,
      },
      // 5. User Management
      {
        title: 'User Management',
        icon: <DsIcon icon="PROFILE" />,
        path: routes.userManagement,
      },
      // 6. Rules & Preferences
      {
        title: 'Rules & Preferences',
        icon: <DsIcon icon="SETTING_COG" />,
        path: routes.rulesPreferences,
      },
      // 7. Timetable Management (with submenu)
      {
        title: 'Timetable Management',
        icon: <DsIcon icon="CALENDAR" />,
        path: routes.timetableManagement.createTimetable,
        submenu: [
          {
            title: 'Create Timetable',
            path: routes.timetableManagement.createTimetable,
            icon: <DsIcon icon="CALENDAR" />,
          },
          {
            title: 'Timetable Views',
            path: routes.timetableManagement.views,
          },
          {
            title: 'Subject Options',
            path: routes.timetableManagement.subjectOptions,
          },
        ],
      },
      // 8. Settings
      {
        title: 'Settings',
        icon: <DsIcon icon="SETTING" />,
        path: routes.settings,
        disabled: true,
      },
      // 9. Analytics
      {
        title: 'Analytics',
        icon: <DsIcon icon="ANALYTICS" />,
        path: routes.analytics,
        disabled: true,
      },
    ]);

    return () => {
      setBackPath('');
    };
  }, [setMenuItems, setBackPath]);

  useEffect(() => {
    loadModuleNamespace('satV5Zone', [
      { jsonFile: sat5AR, lang: 'ar' },
      { jsonFile: sat5DE, lang: 'de' },
      { jsonFile: sat5EN, lang: 'en' },
    ]);
  }, []);

  return <ZoneRoutes />;
};

export default SatV5Zone;
